export const statuses = {
    draft: 'Draft',
    live: 'Live',
    archive: 'Archive',
}
